function Decode(props) {
    if (!props) {
        return null;
    }
    return atob(props);
}

export default Decode;
